// close neighboring details elements when one is opened
( () => {
    const selectors = {
        '.splitkon-faq-in-columns': '.is-style-splitkon-faq-item',
        '.splitkon-faq': '.is-style-splitkon-faq-item',
        '.splitkon-benefits': '.splitkon-benefits-item__details',
        '.splitkon-assortment__items': '.splitkon-assortment-item details',
        '.splitkon-elements__items': '.splitkon-elements-item details',
    }

    Object.entries( selectors ).forEach( ( [sectionSelector, itemSelector] ) => {
        const sections = document.querySelectorAll( sectionSelector );
        sections?.forEach( ( section ) => {
            const items = section.querySelectorAll( `:scope ${ itemSelector }` );
            items?.forEach( ( item ) => {
                item.addEventListener( 'click', () => {
                    if ( !item.open ) {
                        items.forEach( ( otherItem ) => {
                            if ( otherItem !== item ) {
                                otherItem.open = false;
                            }
                        } );
                    }
                } );
            } );
        } );
    } );
} )();

// collapse details elements on mobile and expand on tablet upwards
( () => {
    let prevScreenWidth = 0;
    let screenWidth = window.innerWidth;

    const details = document.querySelectorAll( '.splitkon-text-in-columns details, .splitkon-assortment-item details' );

    function onResize() {
        screenWidth = window.innerWidth;

        if ( prevScreenWidth !== screenWidth ) {
            screenWidth >= 678
                ? details.forEach( ( thisDetails ) => thisDetails.open = true )
                : details.forEach( ( thisDetails ) => thisDetails.open = false );
        }

        prevScreenWidth = screenWidth;
    }

    if ( details ) {
        onResize();
        window.addEventListener( 'resize', onResize );
    }
} )();

// add close button inside details.
// we need to use event delegation to handle the close button click event in the details element
( () => {
    const selectors = {
        '.splitkon-elements-item__details': {
            closeButtonClass: 'splitkon-elements-item__close-popup-button',
            scrollToDetailsTop: false,
            removeModalOverlay: true,
        },
        '.splitkon-gallery__extra-gallery': {
            closeButtonClass:'splitkon-gallery__close-extra-images a',
            scrollToDetailsTop: true,
            removeModalOverlay: false,
        },
    }

    Object.entries( selectors ).forEach( ( [detailsSelector, args] ) => {
        document.querySelectorAll(detailsSelector)?.forEach((details) => {
            details.addEventListener('click', function (e) {
                if (e.target.classList.contains(args.closeButtonClass)) {
                    e.preventDefault();
                    details.open = false;

                    args.removeModalOverlay
                        ? document.documentElement.classList.remove( 'has-modal-open--not-header' )
                        : null;

                    setTimeout(() => {
                        args.scrollToDetailsTop ? details.scrollIntoView( {behavior: 'smooth'} ) : null
                    }, 50)
                }
            });
        });
    })
} )();

// popups that add overlay
(() => {
    const siteHeader = document.querySelector( '.site-header' );
    document.querySelectorAll( '.splitkon-elements-item__details' )?.forEach( ( details ) => {
        details.addEventListener( 'click', ( e ) => {
            if ( 'SUMMARY' === e.target.tagName ) {
                document.documentElement.classList.add( 'has-modal-open--not-header' )
                siteHeader.addEventListener( 'click', () => {
                    details.open = false
                    document.documentElement.classList.remove( 'has-modal-open--not-header' )
                }, { once: true } )
            }
        } );
    });
} )();
